<div class="age-select">
	<div class="age-select__label-container">
		<epi-hint *ngIf="optional" slot="label" class="o-inline-hint">
			Optional
		</epi-hint>
	</div>
	<div class="age-select__container" [class.focused]="isFocused">
		<div class="age-select__container-dropdown">
			<div
				class="age-select__container-dropdown__selected-option"
				[class.clean]="!selectedOption"
				[class.dirty]="selectedOption"
				[attr.id]="'age-select'"
				(click)="onFocus()"
			>
				{{ selectedOption ?? "Select an option" }}
			</div>
			<label
				class="age-select__container-dropdown-label"
				[class.transformed]="isFocused"
				[class.optional]="optional"
				[attr.for]="'age-select'"
				(click)="onFocus()"
			>
				Your Pet's Age
			</label>
			<button
				type="button"
				class="age-select__container-dropdown-menu-button"
				[class.open]="toggleOptions"
				[class.optional]="optional"
				(click)="onFocus()"
				aria-label="Toggle to open and close the expandable list"
				tabindex="0"
			>
				<img
					src="../../../assets/icons/chevron-down.svg"
					alt="Toggle to open and close the expandable list"
				/>
			</button>
			<ul
				*ngIf="toggleOptions"
				class="age-select__container-dropdown__options"
				[class.optional]="optional"
				aria-haspopup="listbox"
				tabindex="0"
			>
				<li
					slot="option"
					id="ageOption999"
					value="999"
					data-quat="input_ageOption999"
					(click)="onOptionChange({ key: 999, value: '0 - 6 weeks old' })"
				>
					0 - 6 weeks old
				</li>
				<li
					*ngFor="let option of options; let i = index"
					:key="option.key"
					slot="option"
					[id]="'ageOption' + option.key"
					[attr.data-quat]="'input_ageOption' + option.key"
					(click)="onOptionChange(option)"
				>
					{{ option.value }}
				</li>
			</ul>
		</div>
	</div>
</div>
